<template>
  <div class="pz-chat-page">
    <!-- 错误页面：客服不存在 -->
    <div v-if="agentNotFound" class="pz-error-container">
      <div class="pz-error-icon">⚠️</div>
      <div class="pz-error-title">链接无效</div>
      <div class="pz-error-message">该客服账号不存在或链接已失效</div>
    </div>

    <!-- 加载中 -->
    <div v-else-if="isVerifying" class="pz-loading-container">
      <div class="pz-loading-spinner"></div>
      <div class="pz-loading-text">正在连接客服...</div>
    </div>

    <!-- 正常聊天界面 -->
    <div v-else class="pz-chat-wrapper">
      <!-- 成功提示 -->
      <div class="pz-success-tip" v-if="showSuccessTip">
        <p>{{ successTipText }}</p>
        <img src="@/assets/pz/icon-satisfaction-5.png" alt="">
      </div>
      
      <!-- 顶部导航 -->
      <div class="pz-header">
        <div class="pz-back" @click="goBack">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="pz-header-info">
          <div class="pz-header-title">盼之客服-{{ agentName }}</div>
          <div class="pz-header-status"><span class="pz-online-status">{{ isAgentOnline ? '在线' : '离线' }}</span> 09:30-00:30</div>
        </div>
      </div>
      
      <!-- 消息区域 -->
      <div class="pz-messages" ref="msgBox">
        <!-- 商品悬浮卡片 -->
        <div v-if="showProductCard" class="pz-product-card">
          <img class="pz-product-img" :src="productImg" alt="">
          <div class="pz-product-info">
            <div class="pz-product-header">
              <p class="pz-product-title">{{ productTitle }}</p>
              <button class="pz-product-close" @click="closeProductCard">×</button>
            </div>
            <div class="pz-product-footer">
              <p class="pz-product-price">￥{{ productPrice }}</p>
              <button class="pz-product-send" @click="sendProductCard">发送商品</button>
            </div>
          </div>
        </div>

        <!-- 评价弹窗 -->
        <div v-if="showAppraise" class="pz-appraise-modal">
          <div class="pz-appraise-content">
            <button class="pz-appraise-close" @click="showAppraise = false">×</button>
            <h2>请对本次客服的服务进行评价</h2>
            <div class="pz-emoji-list">
              <button v-for="(item, index) in emojiList" :key="index" @click="selectEmoji(index)" :class="{ active: selectedEmoji === index }">
                <img :src="selectedEmoji === index ? item.activeImg : item.img" alt="">
                <p>{{ item.text }}</p>
              </button>
            </div>
            <button @click="submitAppraise" class="pz-appraise-submit">提交</button>
          </div>
        </div>

        <!-- 欢迎消息 -->
        <div class="pz-message pz-message-left">
          <img class="pz-avatar" src="@/assets/pz/im_nmCMpsRY.png" alt="">
          <div class="pz-message-content">
            <div class="pz-message-name">盼之客服-{{ agentName }} <span class="pz-official-tag">官方</span></div>
            <div class="pz-bubble pz-bubble-left">
              <span>您好，欢迎咨询盼之平台，请问有什么可以帮您？</span>
            </div>
          </div>
        </div>

        <!-- 消息列表 -->
        <template v-for="message in messages" :key="message.id">
          <!-- 客服消息 -->
          <div v-if="message.speakerType === 2" class="pz-message pz-message-left">
            <img class="pz-avatar" src="@/assets/pz/im_nmCMpsRY.png" alt="">
            <div class="pz-message-content">
              <div class="pz-message-name">盼之客服-{{ agentName }} <span class="pz-official-tag">官方</span></div>
              <div class="payment-card" v-if="isPaymentCard(message.content)">
                <div class="payment-card-header"><div>安全支付</div><img src="@/assets/NaiLong-DFiibrak-NaiLong.png"></div>
                <div class="payment-card-order">订单编号：{{ getPaymentOrderId(message.content) }}</div>
                <div class="payment-card-btn" @click="openPaymentPage(message.content)">前往支付</div>
              </div>
              <!-- 链接卡片 -->
              <div class="link-card-msg" v-else-if="isLinkCardMessage(message.content)">
                <div class="link-card-inner">
                  <h4 class="link-card-title">{{ parseLinkCardMessage(message.content)?.title }}</h4>
                  <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(message.content)?.link)">{{ parseLinkCardMessage(message.content)?.btnText || '查看详情' }}</div>
                </div>
              </div>
              <div class="pz-bubble pz-bubble-left" v-else>
                <img v-if="isImageMessage(message.content)" :src="getImageUrl(message.content)" class="pz-msg-image" referrerpolicy="no-referrer" @click="previewImage(message.content)">
                <span v-else v-html="formatContent(message.content)"></span>
              </div>
            </div>
          </div>
          <!-- 买家消息 -->
          <div v-else class="pz-message pz-message-right">
            <div class="pz-message-content">
              <div class="payment-card" v-if="isPaymentCard(message.content)">
                <div class="payment-card-header"><div>安全支付</div><img src="@/assets/NaiLong-DFiibrak-NaiLong.png"></div>
                <div class="payment-card-order">订单编号：{{ getPaymentOrderId(message.content) }}</div>
                <div class="payment-card-btn" @click="openPaymentPage(message.content)">前往支付</div>
              </div>
              <!-- 链接卡片 -->
              <div class="link-card-msg" v-else-if="isLinkCardMessage(message.content)">
                <div class="link-card-inner">
                  <h4 class="link-card-title">{{ parseLinkCardMessage(message.content)?.title }}</h4>
                  <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(message.content)?.link)">{{ parseLinkCardMessage(message.content)?.btnText || '查看详情' }}</div>
                </div>
              </div>
              <div class="pz-bubble pz-bubble-right" v-else>
                <img v-if="isImageMessage(message.content)" :src="getImageUrl(message.content)" class="pz-msg-image" referrerpolicy="no-referrer" @click="previewImage(message.content)">
                <span v-else v-html="formatContent(message.content)"></span>
              </div>
            </div>
            <img class="pz-avatar" src="@/assets/pz.jpg" alt="">
          </div>
        </template>
      </div>
      
      <!-- 底部输入区域 -->
      <div class="pz-input-area">
        <div class="pz-input-wrapper">
          <input 
            v-model="inputMessage" 
            class="pz-input" 
            placeholder="请输入消息内容"
            @keypress.enter="sendMessage"
          >
        </div>
        <label class="pz-plus-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="11" stroke="#333" stroke-width="1.5"/>
            <path d="M12 7v10M7 12h10" stroke="#333" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input type="file" accept="image/*" style="display:none" @change="uploadImage" ref="imageInput">
        </label>
        <button v-if="inputMessage.trim()" class="pz-send-btn" @click="sendMessage">发送</button>
      </div>
    </div>

    <!-- 图片预览模态框 -->
    <div class="image-preview-modal" :class="{ active: imagePreviewVisible }" @click.self="closeImagePreview">
      <img class="image-preview-content" :src="previewImageUrl" alt="预览图片">
    </div>
  </div>
</template>

<script>
import { apiFetch, API_BASE_URL } from '@/config/api'
import { chatWebSocket } from '@/utils/websocket'
export default {
  name: 'PzChat',
  data() {
    return {
      // 状态
      agentNotFound: false,
      isVerifying: true,
      isAgentOnline: true,

      // 客服信息
      agentAccount: '',
      agentName: '白菜',

      // 会话信息
      sessionId: '',
      customerName: '',
      messages: [],
      lastMessageId: 0,
      pollingInterval: null,
      pollingTimer: null,
      statusPollingInterval: null,
      wsUnsubscribe: null,
      
      // 输入
      inputMessage: '',
      
      // 商品卡片
      showProductCard: false,
      productImg: '',
      productTitle: '',
      productPrice: '',
      productInfo: '',
      
      // 评价
      showAppraise: false,
      selectedEmoji: -1,
      emojiList: [
        { img: '@/assets/pz/icon-satisfaction-1.png', activeImg: '@/assets/pz/icon-satisfaction-1.png', text: '非常不满意' },
        { img: '@/assets/pz/icon-satisfaction-2.png', activeImg: '@/assets/pz/icon-satisfaction-2.png', text: '不满意' },
        { img: '@/assets/pz/icon-satisfaction-3.png', activeImg: '@/assets/pz/icon-satisfaction-3.png', text: '一般' },
        { img: '@/assets/pz/icon-satisfaction-4.png', activeImg: '@/assets/pz/icon-satisfaction-4.png', text: '满意' },
        { img: '@/assets/pz/icon-satisfaction-5.png', activeImg: '@/assets/pz/icon-satisfaction-5.png', text: '非常满意' }
      ],
      
      // 提示
      showSuccessTip: false,
      successTipText: '成功',
      
      // 热点问题
      showHotQuestions: false,
      hotQuestions: [
        '为什么要走盼之平台？',
        '平台靠不靠谱，安全吗？',
        '售后该如何处理？',
        '该平台信誉如何？'
      ],

      // 图片预览
      imagePreviewVisible: false,
      previewImageUrl: '',

    }
  },
  created() {
    this.initFromUrl()
  },
  mounted() {
    this.verifyAgent()
    // 按接口计数访问（sessionStorage去重，同一会话只计一次）
    const _up = new URLSearchParams(window.location.search)
    const _arid = _up.get('arid'), _artype = _up.get('artype')
    if (_arid && _artype) {
      const _dedupKey = `_tv_${_artype}_${_arid}`
      if (!sessionStorage.getItem(_dedupKey)) {
        sessionStorage.setItem(_dedupKey, '1')
        fetch(`${API_BASE_URL}/api/chat/track-visit?linkId=${_arid}&linkType=${_artype}`, { method: 'POST' }).catch(() => {})
      }
    }
    // 注册访客
    const _self = this
    setTimeout(() => {
      if (_self.agentAccount && _self.customerName) {
        fetch(`${API_BASE_URL}/api/chat/register-visit`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({sessionKey: `${_self.customerName}_${_self.agentAccount}`, agent: _self.agentAccount, customerName: _self.customerName, platform: 'pz'}) }).catch(() => {})
      }
    }, 2000)
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    // 监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeUnmount() {
    this.stopPolling()
    this.updateOnlineStatus(false)
    this.disconnectWebSocket()
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    // 从URL获取参数
    initFromUrl() {
      const urlParams = new URLSearchParams(window.location.search)
      this.agentAccount = urlParams.get('custuuid') || urlParams.get('agent') || urlParams.get('xy') || 'admin'
      this.productImg = urlParams.get('image') || ''
      this.productTitle = urlParams.get('title') || ''
      this.productPrice = urlParams.get('price') || ''
      this.productInfo = urlParams.get('info') || ''
      
      if (this.productImg && this.productTitle) {
        this.showProductCard = true
      }
      
      // 生成客户名称和会话ID（与ZzChat.vue保持一致）
      this.customerName = this.getOrCreateCustomerName()
      this.sessionId = `${this.customerName}_${this.agentAccount}`
    },
    
    // 生成随机客户名称
    generateCustomerName() {
      const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let result = 'pz_'
      for (let i = 0; i < 8; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return result
    },
    
    // 获取或创建客户名称（按客服账号存储）
    getOrCreateCustomerName() {
      const storageKey = `pz_customer_name_${this.agentAccount}`
      let name = localStorage.getItem(storageKey)
      if (!name) {
        name = this.generateCustomerName()
        localStorage.setItem(storageKey, name)
      }
      return name
    },
    
    // 验证客服（网络异常自动重试，直到成功）
    async verifyAgent() {
      let verified = false
      while (!verified) {
        try {
          const response = await apiFetch(`/api/chat/verify-agent?agentAccount=${encodeURIComponent(this.agentAccount)}`)
          if (response.code === 0 && response.data?.exists) {
            this.agentNotFound = false
            if (response.data?.agentAccount) this.agentAccount = response.data.agentAccount
            this.isVerifying = false
            this.loadMessages()
            this.connectWebSocket()
            this.startPolling()
            this.updateOnlineStatus(true)
            verified = true
            return
          } else {
            this.agentNotFound = true
            this.isVerifying = false
            verified = true
            return
          }
        } catch (e) {
          console.error('验证客服失败，2秒后重试...', e)
          await new Promise(resolve => setTimeout(resolve, 2000))
        }
      }
    },

    // 连接 WebSocket
    async connectWebSocket() {
      try {
        await chatWebSocket.connect(this.sessionId)
        this.wsUnsubscribe = chatWebSocket.onMessage((data) => {
          this.handleWebSocketMessage(data)
        })
        console.log('WebSocket 连接成功')
      } catch (e) {
        console.log('WebSocket 连接失败，使用轮询:', e)
      }
    },

    // 处理 WebSocket 消息
    handleWebSocketMessage(data) {
      if (data.type === 'newMessage' && data.sessionKey === this.sessionId) {
        // 跳过自己发送的消息（客户端speakerType=1），已通过乐观更新添加
        if (data.speakerType === 1) {
          // Find temp message and replace its ID with real ID
          const tempIdx = this.messages.findIndex(m =>
            m.content === data.content && m.id > 1000000000000
          )
          if (tempIdx !== -1) {
            this.messages[tempIdx].id = data.id
            this.lastMessageId = Math.max(this.lastMessageId, data.id)
          }
          return
        }
        const existingIds = new Set(this.messages.map(m => m.id))
        if (!existingIds.has(data.id)) {
          this.messages.push({
            id: data.id,
            speakerType: data.speakerType,
            content: data.content,
            createdAt: data.createdAt
          })
          if (data.id > this.lastMessageId) {
            this.lastMessageId = data.id
          }
          this.scrollToBottom()
          if (data.speakerType === 2) {
            this.updateReadPosition(data.id)
          }
        }
      }
    },

    // 断开 WebSocket
    disconnectWebSocket() {
      if (this.wsUnsubscribe) {
        this.wsUnsubscribe()
        this.wsUnsubscribe = null
      }
    },
    
    // 加载消息
    async loadMessages() {
      try {
        // 客户端查看消息，viewerType=customer
        const response = await apiFetch(`/api/chat/messages?sessionId=${encodeURIComponent(this.sessionId)}&viewerType=customer`)
        if (response.code === 0 && response.data) {
          this.messages = response.data
          if (this.messages.length > 0) {
            this.lastMessageId = Math.max(...this.messages.map(m => m.id))
            // 上报客户已读位置
            this.updateReadPosition(this.lastMessageId)
          }
          this.scrollToBottom()
        }
      } catch (e) {
        console.error('加载消息失败:', e)
      }
    },
    
    // 轮询新消息
    async pollMessages() {
      try {
        const response = await apiFetch(`/api/chat/poll?sessionId=${encodeURIComponent(this.sessionId)}&lastId=${this.lastMessageId}`)
        if (response.code === 0 && response.data && response.data.length > 0) {
          const existingIds = new Set(this.messages.map(m => m.id))
          const newMessages = response.data.filter(m => !existingIds.has(m.id))
          if (newMessages.length > 0) {
            this.messages.push(...newMessages)
            this.lastMessageId = Math.max(...response.data.map(m => m.id))
            this.scrollToBottom()
            // 只有收到新的客服消息时才上报已读位置
            if (newMessages.some(m => m.speakerType === 2)) {
              this.updateReadPosition(this.lastMessageId)
            }
          }
        }
      } catch (e) {
        console.log('轮询错误:', e)
      }
      // 更新在线状态
      this.updateOnlineStatus(true)
    },
    
    // 上报已读位置（新的已读逻辑）
    async updateReadPosition(lastReadMessageId) {
      if (!lastReadMessageId) return
      try {
        await apiFetch('/api/chat/read-position', {
          method: 'POST',
          body: JSON.stringify({
            sessionId: this.sessionId,
            userType: 'customer',
            lastReadMessageId: lastReadMessageId
          })
        })
      } catch (e) {
        console.log('更新已读位置失败:', e)
      }
    },
    
    // 发送消息
    async sendMessage() {
      const content = this.inputMessage.trim()
      if (!content) return

      // 乐观更新
      const tempId = Date.now()
      this.messages.push({
        id: tempId,
        speakerType: 1,
        content: content,
        createdAt: new Date().toISOString()
      })
      this.inputMessage = ''
      this.scrollToBottom()

      let success = false
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const response = await apiFetch('/api/chat/send', {
            method: 'POST',
            body: JSON.stringify({
              sessionId: this.sessionId,
              agentAccount: this.agentAccount,
              speakerType: 1,
              content: content,
              customerName: this.customerName,
              platform: 'pz'
            })
          })
          if (response.code === 0 && response.data?.messageId) {
            const idx = this.messages.findIndex(m => m.id === tempId)
            if (idx !== -1) {
              this.messages[idx].id = response.data.messageId
            }
            this.lastMessageId = Math.max(this.lastMessageId, response.data.messageId)
          }
          success = true
          break
        } catch (e) {
          console.error(`发送消息失败 (尝试 ${attempt + 1}/3):`, e)
          if (attempt < 2) await new Promise(r => setTimeout(r, 1000))
        }
      }
      if (success) {
        setTimeout(() => this.pollMessages(), 500)
      }
    },
    
    // 发送商品卡片
    async sendProductCard() {
      const content = `<div class="orders-crad"><p class="title1">${this.productTitle}</p><div class="image-info"><img src="${this.productImg}" alt=""><div class="info-text-box"><p class="info-text1">${this.productInfo}</p><p class="info-Price">￥${this.productPrice}</p></div></div></div>`

      const tempId = Date.now()
      this.messages.push({
        id: tempId,
        speakerType: 1,
        content: content,
        createdAt: new Date().toISOString()
      })
      this.showProductCard = false
      this.scrollToBottom()

      try {
        const response = await apiFetch('/api/chat/send', {
          method: 'POST',
          body: JSON.stringify({
            sessionId: this.sessionId,
            agentAccount: this.agentAccount,
            speakerType: 1,
            content: content,
            customerName: this.customerName,
            platform: 'pz'
          })
        })
        if (response.code === 0 && response.data?.messageId) {
          const idx = this.messages.findIndex(m => m.id === tempId)
          if (idx !== -1) {
            this.messages[idx].id = response.data.messageId
          }
          this.lastMessageId = Math.max(this.lastMessageId, response.data.messageId)
        }
      } catch (e) {
        console.error('发送商品卡片失败:', e)
      }
    },

    // 上传图片
    async uploadImage(event) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('file', file)

      try {
        const response = await fetch(`${API_BASE_URL}/api/chat/upload-image`, {
          method: 'POST',
          body: formData
        })
        const result = await response.json()
        if (result.code === 0 && result.data?.imagePath) {
          const imageContent = `[img]${result.data.imagePath}[/img]`
          const tempId = Date.now()

          this.messages.push({
            id: tempId,
            speakerType: 1,
            content: imageContent,
            createdAt: new Date().toISOString()
          })
          this.scrollToBottom()

          const res = await apiFetch('/api/chat/send', {
            method: 'POST',
            body: JSON.stringify({
              sessionId: this.sessionId,
              agentAccount: this.agentAccount,
              speakerType: 1,
              content: imageContent,
              customerName: this.customerName,
              platform: 'pz'
            })
          })
          if (res.code === 0 && res.data?.messageId) {
            const idx = this.messages.findIndex(m => m.id === tempId)
            if (idx !== -1) {
              this.messages[idx].id = res.data.messageId
            }
            this.lastMessageId = Math.max(this.lastMessageId, res.data.messageId)
          }
        }
      } catch (e) {
        console.error('上传图片失败:', e)
      }

      this.$refs.imageInput.value = ''
    },
    
    // 更新在线状态（使用 customerName 而不是 sessionId）
    async updateOnlineStatus(isOnline) {
      try {
        await apiFetch('/api/chat/online-status', {
          method: 'POST',
          body: JSON.stringify({
            username: this.customerName,
            userType: 'customer',
            isOnline: isOnline
          })
        })
      } catch (e) {
        console.log('更新在线状态失败:', e)
      }
    },
    
    // 页面关闭前处理
    handleBeforeUnload() {
      // 使用 sendBeacon 发送离线状态（页面关闭时更可靠）
      const data = JSON.stringify({
        username: this.customerName,
        userType: 'customer',
        isOnline: false
      })
      if (navigator.sendBeacon) {
        const blob = new Blob([data], { type: 'application/json' })
        navigator.sendBeacon(`${API_BASE_URL}/api/chat/online-status`, blob)
      }
    },

    // 页面可见性变化处理
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // 页面变为可见：检查WS健康，重连，加载消息，恢复轮询
        if (!chatWebSocket.isConnected()) {
          this.connectWebSocket()
        }
        this.loadMessages()
        this.pollMessages()
        this.startPolling()
      } else {
        // 页面隐藏：暂停所有轮询，节省服务器资源
        this.stopPolling()
      }
    },
    
    // 开始轮询
    startPolling() {
      // 消息轮询（自适应间隔：WebSocket连接时15s，断开时3s）
      const scheduleMessagePoll = () => {
        const delay = chatWebSocket.isConnected() ? 15000 : 3000
        this.pollingTimer = setTimeout(() => {
          this.pollMessages().then(() => {
            if (this.pollingTimer !== null) scheduleMessagePoll()
          })
        }, delay)
      }
      scheduleMessagePoll()
      // 在线状态/心跳轮询（每4秒）
      this.statusPollingInterval = setInterval(() => {
        this.updateOnlineStatus(true)
      }, 4000)
      // 已读位置上报（每30秒）
      this.readPositionInterval = setInterval(() => {
        if (this.lastMessageId && document.visibilityState === 'visible') this.updateReadPosition(this.lastMessageId)
      }, 30000)
    },

    // 停止轮询
    stopPolling() {
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer)
        this.pollingTimer = null
      }
      if (this.statusPollingInterval) {
        clearInterval(this.statusPollingInterval)
        this.statusPollingInterval = null
      }
      if (this.readPositionInterval) {
        clearInterval(this.readPositionInterval)
        this.readPositionInterval = null
      }
    },
    
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.msgBox) {
          this.$refs.msgBox.scrollTop = this.$refs.msgBox.scrollHeight
        }
      })
    },
    
    // 判断是否是图片消息
    isImageMessage(content) {
      if (!content) return false
      const c = content.trim()
      return (c.startsWith('[图片:') && c.endsWith(']')) ||
             (c.includes('[img]') && c.includes('[/img]'))
    },
    
    // 判断是否是支付卡片
    isPaymentCard(content) {
      return content && /#payid\d+#/.test(content)
    },
    
    // 获取支付订单号
    getPaymentOrderId(content) {
      const m = content && content.match(/#payid(\d+)#/)
      return m ? m[1] : ''
    },
    
    // 打开支付页面
    openPaymentPage(content) {
      const orderId = this.getPaymentOrderId(content)
      if (orderId) window.open(`${window.location.origin}/payment?order=${orderId}`, '_blank')
    },

    isLinkCardMessage(content) {
      return content && content.startsWith('[卡片:') && content.endsWith(']')
    },
    parseLinkCardMessage(content) {
      if (!this.isLinkCardMessage(content)) return { title: '', btnText: '查看详情', link: '' }
      var inner = content.slice(4, -1)
      var lastHttpIndex = inner.lastIndexOf(':http')
      if (lastHttpIndex === -1) {
        var parts = inner.split(':')
        if (parts.length >= 3) {
          var link = parts.pop()
          var btnText = parts.pop()
          return { title: parts.join(':'), btnText: btnText, link: link }
        }
        return { title: inner, btnText: '查看详情', link: '' }
      }
      var link = inner.substring(lastHttpIndex + 1)
      var beforeLink = inner.substring(0, lastHttpIndex)
      var lastColon = beforeLink.lastIndexOf(':')
      if (lastColon === -1) {
        return { title: beforeLink, btnText: '查看详情', link: link }
      }
      return {
        title: beforeLink.substring(0, lastColon),
        btnText: beforeLink.substring(lastColon + 1) || '查看详情',
        link: link
      }
    },
    openCardLink(link) { if (link) window.open(link, '_blank') },

    // 获取图片URL
    getImageUrl(content) {
      if (!this.isImageMessage(content)) return ''

      let imagePath = ''
      const c = content.trim()
      if (c.startsWith('[图片:') && c.endsWith(']')) {
        imagePath = c.slice(4, -1)
        // HTML 反转义
        imagePath = imagePath
          .replace(/&#x2F;/g, '/')
          .replace(/&#x3A;/g, ':')
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&#39;/g, "'")
      } else if (c.includes('[img]') && c.includes('[/img]')) {
        const match = c.match(/\[img\](.*?)\[\/img\]/i)
        if (match && match[1]) {
          imagePath = match[1]
          // HTML 反转义（后端存储时可能对特殊字符做了转义）
          imagePath = imagePath
            .replace(/&#x2F;/g, '/')
            .replace(/&#x3A;/g, ':')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#39;/g, "'")
        }
      }

      if (!imagePath) return ''

      // 如果是完整URL（OSS云存储），直接返回
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath
      }

      // 否则是本地存储，拼接API路径
      return `${API_BASE_URL}/api/chat/image/${imagePath}`
    },

    // HTML转义，防止XSS攻击
    escapeHtml(text) {
      if (!text) return ''
      const div = document.createElement('div')
      div.textContent = text
      return div.innerHTML
    },

    // 格式化内容（带XSS防护）
    formatContent(content) {
      return this.escapeHtml(content)
    },
    
    // 预览图片
    previewImage(content) {
      const url = this.getImageUrl(content)
      if (url) {
        this.previewImageUrl = url
        this.imagePreviewVisible = true
      }
    },

    // 关闭图片预览
    closeImagePreview() {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    },

    // 返回
    goBack() {
      history.back()
    },
    
    // 关闭商品卡片
    closeProductCard() {
      this.showProductCard = false
    },
    
    // 选择评价
    selectEmoji(index) {
      this.selectedEmoji = index
    },
    
    // 提交评价
    submitAppraise() {
      this.showAppraise = false
      this.showSuccessTip = true
      this.successTipText = '评价成功'
      setTimeout(() => {
        this.showSuccessTip = false
      }, 2000)
    },
    
    // 发送热点问题
    sendHotQuestion(question) {
      this.inputMessage = question
      this.sendMessage()
      this.showHotQuestions = false
    },
  }
}
</script>

<style scoped>
.pz-chat-page {
  width: 100%;
  height: 100vh;
  height: var(--app-height, 100dvh);
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 错误和加载状态 */
.pz-error-container,
.pz-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #fff;
}
.pz-error-icon { font-size: 48px; margin-bottom: 16px; }
.pz-error-title { font-size: 20px; font-weight: bold; color: #333; margin-bottom: 8px; }
.pz-error-message { font-size: 14px; color: #666; }
.pz-loading-spinner {
  width: 40px; height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #e8b4b8;
  border-radius: 50%;
  animation: pz-spin 1s linear infinite;
}
.pz-loading-text { margin-top: 16px; color: #666; }
@keyframes pz-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 聊天容器 */
.pz-chat-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f8f4f4;
  overflow: hidden;
}

/* 顶部导航 */
.pz-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.pz-back {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.pz-header-info {
  flex: 1;
  margin-left: 8px;
}
.pz-header-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.pz-header-status {
  font-size: 12px;
  color: #666;
}
.pz-online-status {
  color: #4caf50;
  margin-top: 2px;
}

/* 消息区域 */
.pz-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f4f4;
}

/* 消息项 */
.pz-message {
  display: flex;
  margin-bottom: 16px;
  align-items: flex-start;
}
.pz-message-left {
  flex-direction: row;
}
.pz-message-right {
  flex-direction: row;
  justify-content: flex-end;
}
.pz-message-right .pz-message-content {
  order: 1;
}
.pz-message-right .pz-avatar {
  order: 2;
}
.pz-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}
.pz-message-content {
  max-width: 70%;
  margin: 0 10px;
}
.pz-message-name {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.pz-official-tag {
  font-size: 10px;
  color: #FA6464;
  background: #FFEEEE;
  padding: 2px 6px;
  border-radius: 3px;
  border: none;
}
.pz-bubble {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.5;
  word-break: break-word;
}
.pz-bubble-left {
  background: #fff;
  color: #333;
  border-top-left-radius: 2px;
}
.pz-bubble-right {
  background: #f7d6d6;
  color: #333;
  border-top-right-radius: 2px;
}
.pz-msg-image {
  max-width: 200px;
  max-height: 200px;
  min-width: 100px;
  min-height: 100px;
  background-color: #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
}

/* 支付卡片样式 */
.payment-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 10px 12px;
  border-radius: 12px;
  gap: 12px;
  width: 100%;
  max-width: 240px;
}
.payment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.payment-card-header img {
  height: 20px;
}
.payment-card-order {
  font-size: 13px;
  color: #666;
}
.payment-card-btn {
  background: #e62e2e;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.payment-card-btn:active {
  opacity: 0.8;
}

/* 底部输入区域 */
.pz-input-area {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
  gap: 12px;
}
.pz-input-wrapper {
  flex: 1;
  background: #f5f5f5;
  border-radius: 20px;
  padding: 10px 16px;
}
.pz-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 15px;
  outline: none;
}
.pz-input::placeholder {
  color: #999;
}
.pz-plus-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.pz-send-btn {
  background: #f5f5f5;
  border: none;
  padding: 8px 16px;
  border-radius: 18px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  flex-shrink: 0;
}

/* 成功提示 */
.pz-success-tip {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 20px 40px;
  border-radius: 8px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pz-success-tip img {
  width: 40px;
  height: 40px;
  margin-top: 10px;
}

/* 商品卡片 */
.pz-product-card {
  display: flex;
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.pz-product-img {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  object-fit: cover;
}
.pz-product-info {
  flex: 1;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pz-product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.pz-product-title {
  font-size: 14px;
  color: #333;
  flex: 1;
  margin: 0;
}
.pz-product-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}
.pz-product-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pz-product-price {
  font-size: 16px;
  color: #e8b4b8;
  font-weight: 500;
  margin: 0;
}
.pz-product-send {
  background: #e8b4b8;
  color: #fff;
  border: none;
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
}

/* 评价弹窗 */
.pz-appraise-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.pz-appraise-content {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 360px;
  position: relative;
}
.pz-appraise-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}
.pz-appraise-content h2 {
  text-align: center;
  font-size: 16px;
  color: #333;
  margin: 0 0 20px 0;
}
.pz-emoji-list {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
.pz-emoji-list button {
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
}
.pz-emoji-list button.active {
  background: #fef5f5;
}
.pz-emoji-list button img {
  width: 36px;
  height: 36px;
}
.pz-emoji-list button p {
  font-size: 11px;
  color: #666;
  margin: 6px 0 0 0;
}
.pz-appraise-submit {
  width: 100%;
  background: #e8b4b8;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 24px;
  font-size: 15px;
  cursor: pointer;
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.image-preview-modal.active {
  display: flex;
}
.image-preview-content {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

/* 链接卡片消息样式 */
.link-card-msg {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  max-width: 260px;
}
.link-card-inner {
  padding: 0.75rem;
}
.link-card-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link-card-btn {
  display: block;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  background: #007aff;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.link-card-btn:active {
  opacity: 0.8;
}

</style>
